import { Component } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { AuthService } from '../../services/auth.service';


@Component({
  selector: 'app-enrollment-closed',
  standalone: false,
  templateUrl: './enrollment-closed.component.html',
  styleUrl: './enrollment-closed.component.css'
})
export class EnrollmentClosedComponent {
    constructor(private title: Title, private router: Router, private meta: Meta,private authService:AuthService) {
  }
  buttonOneClicked(){
    window.open('https://www.syngenta-us.com/herbicides/storen', '_blank');
  }

  buttonTwoClicked(){
    this.router.navigate(['/log-in']);
  }

   ngOnInit() {
    this.authService.checkAuthAndRedirectHome();
    this.title.setTitle("Enrollment Closed | Storen Satisfaction Program");
    this.meta.updateTag({ name: 'description', content: 'Enrollment period has closed for Storen Satisfaction Program' });
     }

}
